module.exports = __webpack_public_path__ + "static/media/icons_factura.893fb002.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons_factura.svg
// module id = 280
// module chunks = 0